"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var main_1 = require("../../../../../../../../reducers/slices/main");
var react_2 = require("@nextui-org/react");
var remove_unit_assignment_1 = require("../../../../../../../../api/calls/lets-cue/unit/remove/remove_unit_assignment");
var get_unit_assignments_thunk_1 = require("../../../../../../../../reducers/slices/lets_cue/units/thunks/get_unit_assignments_thunk");
var useRowActions = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.unitsState; }), unit_assignments = _a.unit_assignments, pagination = _a.pagination, loading = _a.loading;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_1.useState)(new Set([])), selectedTableCells = _b[0], setSelectedTableCells = _b[1];
    var onSelectionChange = function (keys) {
        if (keys === "all") {
            setSelectedTableCells(keys);
            return;
        }
        var resultKeys = new Set(keys);
        var currentKeys = selectedTableCells === "all" ? new Set(unit_assignments.map(function (item) { return String(item._id); })) : selectedTableCells;
        currentKeys.forEach(function (key) {
            if (!unit_assignments.some(function (item) { return String(item._id) === key; })) {
                resultKeys.add(key);
            }
        });
        setSelectedTableCells(resultKeys);
    };
    var rowActions = function (unit_assignment) { return [
        {
            key: "delete",
            onClick: function () {
                var _a;
                console.log("Delete unit assignment", unit_assignment);
                dispatch((0, main_1.setContentModal)({
                    title: "Confirm removal of ".concat((_a = unit_assignment === null || unit_assignment === void 0 ? void 0 : unit_assignment.customer) === null || _a === void 0 ? void 0 : _a.name, " in unit ").concat(unit_assignment === null || unit_assignment === void 0 ? void 0 : unit_assignment.unit_number, " of building ").concat(unit_assignment === null || unit_assignment === void 0 ? void 0 : unit_assignment.building_number),
                    content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4 flex-col items-center" }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ className: "text-inputText" }, { children: "Are you sure you want to remove this unit assignment?" })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4 justify-center" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Button, __assign({ size: "md", className: "bg-slate-300 text-black", onClick: function () { return dispatch((0, main_1.setContentModal)(null)); } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ size: "md", color: "primary", onClick: function () {
                                            (user === null || user === void 0 ? void 0 : user.role) !== "ADMIN"
                                                ? dispatch((0, main_1.setMessageModal)({
                                                    title: "Access Denied",
                                                    messages: ["You do not have permission to remove unit assignments."],
                                                }))
                                                : (0, remove_unit_assignment_1.remove_unit_assignment)({
                                                    _id: unit_assignment === null || unit_assignment === void 0 ? void 0 : unit_assignment._id,
                                                    building_number: unit_assignment === null || unit_assignment === void 0 ? void 0 : unit_assignment.building_number,
                                                    unit_number: unit_assignment === null || unit_assignment === void 0 ? void 0 : unit_assignment.unit_number,
                                                }).then(function (response) {
                                                    if (response.success) {
                                                        dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                                                        dispatch((0, main_1.setContentModal)(null));
                                                        dispatch((0, get_unit_assignments_thunk_1.get_unit_assignments_thunk)(__assign(__assign({}, pagination), { building_number: String(unit_assignment === null || unit_assignment === void 0 ? void 0 : unit_assignment.building_number), unit_number: unit_assignment === null || unit_assignment === void 0 ? void 0 : unit_assignment.unit_number })));
                                                    }
                                                    else {
                                                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when removing the unit assignment.", messages: [response.message] }));
                                                    }
                                                });
                                        } }, { children: "Continue" }))] }))] }))),
                }));
            },
        },
    ]; };
    return (0, react_1.useMemo)(function () { return ({
        rowActions: rowActions,
        selectedTableCells: selectedTableCells,
        onSelectionChange: onSelectionChange,
    }); }, [rowActions, selectedTableCells, onSelectionChange]);
};
exports.useRowActions = useRowActions;
exports.default = exports.useRowActions;
